var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-fill flex-column justify-content-center"},[_c('p',{staticClass:"mb-0"},[_vm._v(" "+_vm._s(_vm.pushChallengeMessage)+" ")]),_c('h2',{staticClass:"h1 mb-2 mt-4 p-3"},[_vm._v(" "+_vm._s(_vm.pushChallengeNumber)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }